import { Component } from '@angular/core';
import { ContractorService } from '../../services/contractor/contractor.service';

@Component({
	selector: 'pcm-contractor-submission-modal',
	templateUrl: './data-modal-contractor-submission.component.html',
	styleUrls: ['./data-modal-contractor-submission.component.scss'],
})
export class DataModalContractorSubmissionComponent {

	constructor(
		public contractorService: ContractorService,
	) {}

	onUpload(file) {
		this.contractorService.uploadContractors(file);
	}
	
	onSubmit() {
		if(!this.contractorService.files) {
			this.contractorService.fileUploadMessage = 'File has to be uploaded first';
			this.contractorService.fileUploadSuccessMessage = '';
		} else {
			this.contractorService.submitContractorBulk();
		}
	}

	onCloseContractorSubmissionModal() {
		this.contractorService.showContractorSubmissionModal = false;
	}
}
